import * as React from "react";
const SvgPickUp = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20.67 21.75",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "pick_up_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "pick_up_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.33 0A4.39 4.39 0 0 0 6 4.38C6 6.19 9.08 12 10.33 12s4.39-5.81 4.39-7.62A4.39 4.39 0 0 0 10.33 0m0 10.2C9.42 9 7.45 5.73 7.45 4.38a2.89 2.89 0 0 1 5.77 0c0 1.35-1.97 4.62-2.89 5.82",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m10.63 8-.3-.12L10 8c.09.16.19.33.29.48ZM10.11 5.79a2 2 0 0 1 .22 0 1.4 1.4 0 0 1 .22 0 1 1 0 0 1 .15 0l.89.36a5.6 5.6 0 0 0 .63-1.78 2 2 0 0 1-3.77 0 5.8 5.8 0 0 0 .62 1.78l.93-.33s.06-.01.11-.03M10.33 13c-1.13 0-2.5-1.77-3.58-3.74l-3.06 1.22 6.64 2.66L17 10.48l-3.09-1.22C12.84 11.23 11.47 13 10.33 13M11.33 19.27l7.34-2.93v-4.38l-7.34 2.93zM2 16.34l7.33 2.93v-4.38L2 11.96z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20.66 10.47a.8.8 0 0 0-.07-.31.3.3 0 0 0 0-.07 1 1 0 0 0-.19-.27h-.05a.4.4 0 0 0-.1-.09 1 1 0 0 0-.16-.09l-5.3-2.18c-.26.59-.55 1.2-.88 1.8L17 10.48l-6.64 2.66-6.67-2.66 3.06-1.22c-.32-.6-.62-1.21-.87-1.8L.63 9.55a1 1 0 0 0-.16.09 1 1 0 0 0-.11.09 1 1 0 0 0-.18.27v.07a.8.8 0 0 0-.06.31H0V17a1 1 0 0 0 .63 1l9.31 3.72a1 1 0 0 0 .37.07.9.9 0 0 0 .37-.07L20 18a1 1 0 0 0 .63-.93v-6.59Zm-11.33 8.8L2 16.34V12l7.33 2.93Zm9.34-2.93-7.34 2.93v-4.38L18.67 12Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 10.33,
	cy: 3.75,
	r: 1,
	style: { fill: "currentColor" }
}))));
export default SvgPickUp;
